import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-delete-cart-confirmation',
    templateUrl: './delete-cart-confirmation.component.html',
    styleUrls: ['./delete-cart-confirmation.component.scss'],
    standalone: false
})
export class DeleteCartConfirmationComponent {
  constructor( private dialogRef: MatDialogRef<DeleteCartConfirmationComponent>){
    
  }

  close(){
    this.dialogRef.close(false);
  }
  
  accept(){
    this.dialogRef.close(true);
  }
}
